import { render, staticRenderFns } from "./SanityPhotoAlbumSerializer.vue?vue&type=template&id=d1dd36e0&scoped=true&"
import script from "./SanityPhotoAlbumSerializer.vue?vue&type=script&lang=ts&"
export * from "./SanityPhotoAlbumSerializer.vue?vue&type=script&lang=ts&"
import style0 from "./SanityPhotoAlbumSerializer.vue?vue&type=style&index=0&id=d1dd36e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dd36e0",
  null
  
)

export default component.exports